import React from "react";

import {
  faDatabase,
  faPlay,
  faWarning,
} from "@fortawesome/pro-regular-svg-icons";

import { Callout } from "src/design-system/Callout";
import { EmptyState } from "src/design-system/EmptyState";
import { ColumnType } from "src/featureCatalogue/Queries/Create/helpers";
import { SQLPreviewTable } from "src/featureCatalogue/Queries/SQLResonsePreviewTable";
import { UseFeatureQueryPreview } from "src/featureCatalogue/queries";
import { errorMessage } from "src/utils/stringUtils";

export const SQLResponsePreview: React.FC<{
  featurePreview: UseFeatureQueryPreview;
  columnTypes: Record<string, ColumnType>;
  onColumnTypeChange: (column: string, type: ColumnType) => void;
}> = ({ featurePreview, columnTypes, onColumnTypeChange }) => {
  const isServerError = featurePreview.error?.response?.status === 500;
  const errorTitle = isServerError
    ? "We have received an unexpected error"
    : "Syntax error";

  const errorDetail = featurePreview.error?.response?.data.detail
    ? errorMessage(featurePreview.error.response.data.detail)
    : "Our team has been notified";

  if (!featurePreview.error && featurePreview.previewData?.data?.length === 0) {
    return (
      <div>
        <Callout icon={faWarning} type="error">
          No data found for the selected time range.
          <br />
          Please adjust the end date and time or choose a different time window,
          and try running the query again.
        </Callout>
      </div>
    );
  }

  return (
    <div className="decideScrollbar flex h-full flex-col overflow-hidden">
      {featurePreview.isIdle && (
        <div className="flex flex-1 justify-center">
          <EmptyState
            description="SQL response will help you define Features that can be utilised by Decision Flows"
            headline="Run Query to see SQL response"
            icon={faPlay}
          />
        </div>
      )}
      {featurePreview.error && (
        <EmptyState
          description={errorDetail}
          headline={errorTitle}
          icon={faDatabase}
          variant="error"
        />
      )}
      {!featurePreview.error &&
        (featurePreview.previewData || featurePreview.isPending) && (
          <SQLPreviewTable
            columnTypes={columnTypes}
            dataLoc={
              featurePreview.isPending
                ? "sql-preview-table-loading"
                : "sql-preview-table"
            }
            isLoading={featurePreview.isPending}
            rows={featurePreview.previewData?.data}
            onColumnTypeChange={onColumnTypeChange}
          />
        )}
    </div>
  );
};
